import * as Types from '@/types/schema';

import gql from 'graphql-tag';
import { SkillWithMicroSkillDetailsFragmentDoc, MicroSkillFragmentDoc } from '../../../../../../../../skill-matrix/views/SkillsManager/components/Dialogs/components/SkillsDetails/graphql/query/generated/skillMicroSkillDetails';
import { SkillDetailsFragmentDoc } from '../../../../../../../../skill-matrix/graphql/fragment/generated/SkillDetails';
import * as Urql from '@/utils/urql';
export type Omit<T, K extends keyof T> = Pick<T, Exclude<keyof T, K>>;
export type OrgRoleSkillTrackDetailsFragment = { id: string, skillMatrixConfig?: { __typename: 'SkillMatrixConfig', skillMatrixId?: string | null, skillMasteryConfigs: Array<{ __typename: 'SkillMasteryConfig', skillId: string, expectedScore: number }> } | null };


export type OrgRoleSkillTrackDetailsFragmentVariables = Types.Exact<{ [key: string]: never; }>;

export type SkillGroupTrackDetailsFragment = { __typename: 'SkillGroupType', _id: string, name: string, skills?: Array<{ __typename: 'SkillType', childrenIds?: Array<string> | null, id: string, name: string, description?: string | null, type: Types.SkillTypeEnum, systemGenerated?: boolean | null, childSkills?: Array<{ id: string, name: string, childrenIds?: Array<string> | null, parentIds?: Array<string> | null }> | null, scaleConfig?: { maxScore: number, minScore: number, scaleType: Types.ScaleConfigEnum } | null, rubrics: Array<{ label: string, score?: number | null, description?: string | null, maxScore?: number | null, minScore?: number | null }>, iconSettings?: { value: string, type: Types.IconTypeEnum, iconColor?: string | null } | null }> | null };


export type SkillGroupTrackDetailsFragmentVariables = Types.Exact<{ [key: string]: never; }>;

export type TrackDetailsSkillsFragment = { __typename: 'TrackType', id: string, name: string, skillMatrix?: { __typename: 'SkillMatrixType', id: string, skillGroups: Array<{ __typename: 'SkillGroupType', _id: string, name: string, skills?: Array<{ __typename: 'SkillType', childrenIds?: Array<string> | null, id: string, name: string, description?: string | null, type: Types.SkillTypeEnum, systemGenerated?: boolean | null, childSkills?: Array<{ id: string, name: string, childrenIds?: Array<string> | null, parentIds?: Array<string> | null }> | null, scaleConfig?: { maxScore: number, minScore: number, scaleType: Types.ScaleConfigEnum } | null, rubrics: Array<{ label: string, score?: number | null, description?: string | null, maxScore?: number | null, minScore?: number | null }>, iconSettings?: { value: string, type: Types.IconTypeEnum, iconColor?: string | null } | null }> | null }> } | null, orgRoles?: Array<{ id: string, skillMatrixConfig?: { __typename: 'SkillMatrixConfig', skillMatrixId?: string | null, skillMasteryConfigs: Array<{ __typename: 'SkillMasteryConfig', skillId: string, expectedScore: number }> } | null }> | null };


export type TrackDetailsSkillsFragmentVariables = Types.Exact<{ [key: string]: never; }>;

export type TrackDetailsSkillsQueryVariables = Types.Exact<{
  filters?: Types.InputMaybe<Types.TrackFilters>;
}>;


export type TrackDetailsSkillsQuery = { track?: { __typename: 'TrackType', id: string, name: string, skillMatrix?: { __typename: 'SkillMatrixType', id: string, skillGroups: Array<{ __typename: 'SkillGroupType', _id: string, name: string, skills?: Array<{ __typename: 'SkillType', childrenIds?: Array<string> | null, id: string, name: string, description?: string | null, type: Types.SkillTypeEnum, systemGenerated?: boolean | null, childSkills?: Array<{ id: string, name: string, childrenIds?: Array<string> | null, parentIds?: Array<string> | null }> | null, scaleConfig?: { maxScore: number, minScore: number, scaleType: Types.ScaleConfigEnum } | null, rubrics: Array<{ label: string, score?: number | null, description?: string | null, maxScore?: number | null, minScore?: number | null }>, iconSettings?: { value: string, type: Types.IconTypeEnum, iconColor?: string | null } | null }> | null }> } | null, orgRoles?: Array<{ id: string, skillMatrixConfig?: { __typename: 'SkillMatrixConfig', skillMatrixId?: string | null, skillMasteryConfigs: Array<{ __typename: 'SkillMasteryConfig', skillId: string, expectedScore: number }> } | null }> | null } | null };

export const SkillGroupTrackDetailsFragmentDoc = /*#__PURE__*/ gql`
    fragment SkillGroupTrackDetails on SkillGroupType {
  _id
  name
  skills {
    ...SkillWithMicroSkillDetails
    __typename
  }
  __typename
}
    `;
export const OrgRoleSkillTrackDetailsFragmentDoc = /*#__PURE__*/ gql`
    fragment OrgRoleSkillTrackDetails on OrgRoleType {
  id
  skillMatrixConfig {
    skillMatrixId
    skillMasteryConfigs {
      skillId
      expectedScore
      __typename
    }
    __typename
  }
}
    `;
export const TrackDetailsSkillsFragmentDoc = /*#__PURE__*/ gql`
    fragment TrackDetailsSkills on TrackType {
  id
  name
  skillMatrix {
    id
    skillGroups {
      ...SkillGroupTrackDetails
      __typename
    }
    __typename
  }
  orgRoles {
    ...OrgRoleSkillTrackDetails
  }
  __typename
}
    `;
export const TrackDetailsSkillsDocument = /*#__PURE__*/ gql`
    query trackDetailsSkills($filters: TrackFilters) {
  track(filters: $filters) {
    ...TrackDetailsSkills
  }
}
    ${TrackDetailsSkillsFragmentDoc}
${SkillGroupTrackDetailsFragmentDoc}
${SkillWithMicroSkillDetailsFragmentDoc}
${SkillDetailsFragmentDoc}
${MicroSkillFragmentDoc}
${OrgRoleSkillTrackDetailsFragmentDoc}`;

export function useTrackDetailsSkillsQuery(options?: Omit<Urql.UseQueryArgs<TrackDetailsSkillsQueryVariables>, 'query'>) {
  return Urql.useQuery<TrackDetailsSkillsQuery, TrackDetailsSkillsQueryVariables>({ query: TrackDetailsSkillsDocument, ...options });
};